import {Injectable} from '@angular/core';

@Injectable()
export class AppConstants {
  // static markingSchemes = [
  //   {'name': 'Percentage', 'value': 'PERCENTAGE'},
  //   {'name': 'CGPA', 'value': 'CGPA'}
  // ];
  //
  // static boardUniversity = [
  //   {'name': 'CBSE', 'value': 'CBSE'},
  //   {'name': 'ICSE', 'value': 'ICSE'},
  //   {'name': 'IB', 'value': 'IB'},
  //   {'name': 'State Board', 'value': 'STATE_BOARD'}
  // ];
  //
  // static categories = [
  //   {'name': 'General', 'value': 'GENERAL'},
  //   {'name': 'OBC', 'value': 'OBC'},
  //   {'name': 'SC', 'value': 'SC'},
  //   {'name': 'ST', 'value': 'ST'},
  //   {'name': 'Others', 'value': 'OTHERS'},
  // ];

  // static employementStatuses = [
  //   {'name': 'Employed', 'value': 'EMPLOYED'},
  //   {'name': 'Un-Employed', 'value': 'UN_EMPLOYED'},
  // ];
  //
  // static ticketStatuses = [
  //   {
  //     'name': 'Pending',
  //     'value': 'PENDING'
  //   },
  //   {
  //     'name': 'Resoled',
  //     'value': 'RESOLVED'
  //   },
  //   {
  //     'name': 'Withdrawn',
  //     'value': 'WITHDRAWN'
  //   },
  //   {
  //     'name': 'To be Taken Later',
  //     'value': 'TO_BE_TAKEN_LATER'
  //   }
  // ];
   static courses = [
        { id: 1, name: "Certificate in Business English", duration: "8 Weeks", fee: 750 },
        { id: 2, name: "Certificate in Teaching English for Specific Purposes", duration: "4 Weeks", fee: 750 },
        { id: 3, name: "Certificate in Teaching English to Young Learners", duration: "4 Weeks", fee: 750 },
        { id: 4, name: "Certificate in Cyber Security", duration: "8 Weeks", fee: 600 },
        { id: 5, name: "Certificate in Entrepreneurship", duration: "4 Weeks", fee: 500 },
        { id: 6, name: "Certificate in Marketing", duration: "4 Weeks", fee: 500 },
        { id: 7, name: "Certificate in Finance", duration: "4 Weeks", fee: 500 },
        { id: 8, name: "Certificate in Human Resource (HR)", duration: "4 Weeks", fee: 500 },
        { id: 9, name: "Bachelor in Hospitality & Tourism Management", duration: "30-36 Months", fee: 4000 },
        { id: 10, name: "Bachelor in Psychology Degree", duration: "30-36 Months", fee: 4000 },
        { id: 11, name: "Bachelor of Business Administration Degree", duration: "30-36 Months", fee: 4000 },
        { id: 12, name: "Bachelor of Science in Accountancy", duration: "30-36 Months", fee: 4000 },
        { id: 13, name: "Bachelor in Cyber Security", duration: "30-36 Months", fee: 4000 },
        { id: 14, name: "Bachelor of Science in Information Technology", duration: "30-36 Months", fee: 4000 },
        { id: 15, name: "Master in Cyber Security", duration: "8-12 Months", fee: 3600 },
        { id: 16, name: "Master in Data Science", duration: "8-12 Months", fee: 3600 },
        { id: 17, name: "Master of Arts in Psychology Degree", duration: "8-12 Months", fee: 3600 },
        { id: 18, name: "Master of Business Administration Degree", duration: "8-12 Months", fee: 3600 },
        { id: 19, name: "Master of Science in Information Technology", duration: "8-12 Months", fee: 3600 },
        { id: 20, name: "Master of TESOL", duration: "8-12 Months", fee: 3600 },
        { id: 21, name: "Doctorate of Business Administration Degree", duration: "12-18 Months", fee: 9000 },
        { id: 22, name: "PhD Program", duration: "30-36 Months", fee: 9000 }
    ];


}
